<div class="bg-col-w p-a-8">
    <div class="flex flex-middle">
        <h6 class="s1 col-1 flex-grow">{{data.title}}</h6>
        <!-- close button -->
        <button role="button"
                aria-label="Close"
                (click)="close()">
            <i class="icon-close"
               aria-hidden="true"></i>
        </button>
    </div>

    <div class="p1 m-t hideEmpty">{{data.message === 'ERROR' ? 'Unexpected error' : data.message}}</div>
</div>